/** "1 song", "2 songs", "1,204 songs" — counted words read the same everywhere. */
export function count(n: number, one: string, many = `${one}s`): string {
  return `${n.toLocaleString()} ${n === 1 ? one : many}`;
}

export const songs = (n: number) => count(n, "song");
